var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_1224_1467)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1224_1467",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1224_1467",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1224_1467",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAvhJREFUWEfdlk1IFGEYx//PaK0QXsxDJ7MPCRIyik5R2M1DQUQFEe1MK1QXrSDZHfNjy9xZt9BKITDQ3pUQQuscBClEQQSiJEEhZFGQRQcLzXX3fWIt153V2dmNHYTmOPN8/OY/z/N/h7DKF61yf/zHAG2ebYqM1jLoGIBxljyM+YIQ/N0zyao7o4ChVRFxHxjFKZ94hPNlFer6phbv5x7gdo2LZqbHwdhiMV+DrIujzgGEtDKK8VvL4WZ85HpR4hyAoe0h8Ms02/WTdVHoHEBQ3U+MYWsAfs56eG/uAYKeCuJYC4BD6byFSe6Dr++ZPUBI2wBGKWbXjqWujqlBy6lNSr7SwsDJRFHGVcnMpFBzUuxXBgzoosN+DVvdflMy0UNmHoAu+hPJ7dVFyly0lYFzSY1Dcr2rAWe75xfutVcX4VekDPl531FQ+AG1nXOp6ixbQzLUpwAqV5KRQccx9/6R4ioJMKhuSUa6JRWlEd6eH9lauwlACaodzLiQaRFi3JFrI0241P8t05y0CpChvgZQbleMwD0yhiY0hD/Zxdo9NylAhsp2CQCGWBcHMojLKCQFwP0OoK3pMgnokrqoyah6BkFmgKB7EExHbPJmmcgL373ODOrbhpi34MaJYppf8wSgCovMoaUNodE/IL2PbbukCVh+GhpaqQJuZkAzGQbxXekLn0FAO0wkbwK0ceE5YYAp7zy8PZ//BcT6OG7VdoJQCZKTiNIYGsWEqYGhXiSgPcmErsl60WiKWazBsTeIyBe4cn/a1oiyegu/VqC4uI2B2r95U0yogU88QKqbxo9h4hD0cJdJ2awaWgUHTm8nksGkgyhpVsxJrMADr+hNKJcTgMUiAfdBIoqDpDOzEdbFLmcA4lUNrZLA8fPE6pphXaxzEMCzmRAzD6z5o0+wTyTMLvc/pfHNNNRXAHavJAExB2V9WHdOgXjl6+4dFKXRlQBYF2b3zekQJheL/7BEojozygn4IiVP4nLYn1sfyAG9IzOQDdeqA/wGa9UDMNJtY9sAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7d42af486fd8ee60d317d57b4daadf2d.svg";
export { ForwardRef as ReactComponent };